import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import FamilyPortal from "@/pages/FamilyPortal";
import EventsAdmin from "@/pages/EventsAdmin";
import FamilyTree from "@/pages/FamilyTree";
import Gallery from "@/pages/Gallery";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import StatisticsPage from "@/pages/StatisticsPage";
import InMemoriamPage from "@/pages/InMemoriamPage";
import PaymentsPage from "@/pages/PaymentsPage";
import ReunionDuesPage from "@/pages/ReunionDuesPage";
import DocumentsPage from "@/pages/DocumentsPage";
import FamilyLogin from "@/pages/FamilyLogin";
import ReunionPhotosPage from "@/pages/ReunionPhotosPage";
import PwaInstallBanner from "@/components/PwaInstallBanner";

const RequireAdmin = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500">
        Loading...
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

const TOASTER_OPTIONS = {
  style: {
    background: "#fdfbf7",
    color: "#2c2a26",
    border: "1px solid #e6e2d6",
    fontFamily: "Work Sans, sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={TOASTER_OPTIONS} />
          <PwaInstallBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAdmin>
                  <AdminDashboard />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/events"
              element={
                <RequireAdmin>
                  <EventsAdmin />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/tree"
              element={
                <RequireAdmin>
                  <FamilyTree />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/gallery"
              element={
                <RequireAdmin>
                  <Gallery adminMode={true} />
                </RequireAdmin>
              }
            />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/statistics" element={<StatisticsPage />} />
            <Route path="/memoriam" element={<InMemoriamPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/dues" element={<ReunionDuesPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/reunion-photos" element={<ReunionPhotosPage />} />
            <Route path="/family/login" element={<FamilyLogin />} />
            <Route path="/family/:token" element={<FamilyPortal />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
